import keypress from "../../../vendor/assets/javascripts/keypress/keypress.min";

globalThis.keypress = keypress.keypress;
